export default "__VITE_ASSET__B_dIqe____"